import React from 'react';
import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eb/site-structure';

export default class Page extends React.PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
    };

    render() {
        const { env, request, user, footerLinks, children } = this.props;

        /*
        TODO: Remove `hasIndependentScrolling` prop when EB-55349 is resolved.

        Has independent scrolling is only passed through temporarily until a bug
        with the <Structure /> component is worked out. Without it, the app
        is not visible at all.
        */

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                footerLinks={footerLinks}
                hasIndependentScrolling={true}
            >
                {children}
            </SiteStructure>
        );
    }
}
